define.alias("shared/components/shared/publish/switcher/item/publish-method", "settings/components/shared/publish/switcher/item/publish-method");